/**
 * Palette for the project
 */
const palette = {
  
  primary: {
    main: '#395abd', // Button color 
    hover: '#7fc4db', // Button color when hovered
    text: 'white', // Text color for buttons
    exampleText: '#AAAAAA', // Text color for field example hints
    body: '#f3f5f7',
    disabled: '#e0e0e0',
  },
  header: {
    main: '#ebf3ffff', // Header color
  },
  removeBtn: {
    main: '#C70039', // Remove button color
    hover: '#f95281ff', // Remove button color when hovered
    text: '#f4f5f7', // Text color for remove button
  },
  form: {
    background: '#f3f5f7', // Form background color
  },
  stepper: {
    main: '#097969', // Stepper color
    error: '#C70039', // Text color for stepper
    warning: '#c68100ff', // Warning color for stepper
  },

  main: '#00095b',
  hover: '#395abd',
  secondary: '#e1f0ff',
  mainText: '#000000ff',
  secondaryText: '#969696ff',
  body: '#f3f5f7',
  secondaryBody: '#e1f0ff',
  disabled: {
    background: '#cccccc', // Disabled button color
    text: '#666666', // Disabled button color
  },
  warning: '#c68100ff'
};




export default palette;